import { adminApiFetch } from './apiService';

export const productAttributeDefinitionService = {
  // 獲取產品屬性定義列表
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);

    const response = await adminApiFetch(`product_attribute_definitions?${queryParams.toString()}`);
    return response.json();
  },

  // 獲取所有產品屬性定義 ID（用於篩選）
  getIds: async (params = {}) => {
    const response = await adminApiFetch('product_attribute_definitions/get_ids', {
      method: 'POST',
      body: params
    });
    return response.json();
  },

  // 獲取單個產品屬性定義
  get: async (id) => {
    const response = await adminApiFetch(`product_attribute_definitions/${id}`);
    return response.json();
  },

  // 創建產品屬性定義
  create: async (data) => {
    const response = await adminApiFetch('product_attribute_definitions', {
      method: 'POST',
      body: JSON.stringify({ product_attribute_definition: data })
    });
    return response.json();
  },

  // 更新產品屬性定義
  update: async (id, data) => {
    const response = await adminApiFetch(`product_attribute_definitions/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ product_attribute_definition: data })
    });
    return response.json();
  },

  // 刪除產品屬性定義
  delete: async (id) => {
    const response = await adminApiFetch(`product_attribute_definitions/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 重新排序
  batchUpdatePosition: async (ids) => {
    const response = await adminApiFetch('product_attribute_definitions/batch_update_position', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  }
};

export default productAttributeDefinitionService;
